module.exports = __webpack_public_path__ + "media/images/emblems/Vaulion-coat_of_arms-1440f045348617f48ee09f2296814b87.svg";